<!--
 * @Author: your name
 * @Date: 2021-04-01 10:18:41
 * @LastEditTime: 2021-06-12 17:48:26
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \exclusive-cloud-admin\common\src\components\select-user\select-user.vue
-->
<template>
	<div class="select-user-container">
		<efly-screen>
			<!-- <div slot="label">
				<efly-select width="126px" size="small" :data="list" type="screen" :value="label" @change="labelChange($event)"></efly-select>
			</div> -->
			<slot>
				<efly-select width="300px" size="small" :data="billing" main="email" minor="trueName"
							 searchType="interface"
							 :value="billingValue"
							 :defShowDownIcon="true"
							 :defShowSearch="true"
							 @change="userChange($event)" placeholder="请选择客户账号" type="search"
							 @search="getSearch($event)"
							 @hover="selectHover($event)"
							 @input="inputDebounce($event)"
							 @reachBottom="scrollBottom()"></efly-select>
			</slot>
		</efly-screen>
	</div>
</template>

<script>
    import SelectUser from "./select-user";

    export default SelectUser;
</script>

<style lang="scss">
	.select-user-container .efly-screen .efly-select input {
		border-left: 1px solid #dcdfe6 !important;
	}
</style>
